import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container list"
};
const _hoisted_2 = {
  class: "pagination"
};
import { onMounted, ref } from "vue";
import { httpGet } from "@/utils/http";
import { ElMessage } from "element-plus";
import { dateFormat } from "@/utils/libs";

// 用户登录日志

export default {
  __name: 'LoginLog',
  setup(__props) {
    const items = ref([]);
    const loading = ref(true);
    const total = ref(0);
    const page = ref(0);
    const pageSize = ref(0);
    onMounted(() => {
      fetchList(1, 15);
    });

    // 获取数据
    const fetchList = function (_page, _pageSize) {
      httpGet(`/api/admin/user/loginLog?page=${_page}&page_size=${_pageSize}`).then(res => {
        if (res.data) {
          items.value = res.data.items;
          total.value = res.data.total;
          page.value = res.data.page;
          pageSize.value = res.data.page_size;
        }
        loading.value = false;
      }).catch(() => {
        ElMessage.error("获取数据失败");
      });
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          border: "",
          "row-key": row => row.id
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "用户名",
            prop: "username"
          }), _createVNode(_component_el_table_column, {
            label: "登录IP",
            prop: "login_ip"
          }), _createVNode(_component_el_table_column, {
            label: "登录地址",
            prop: "login_address"
          }), _createVNode(_component_el_table_column, {
            label: "登录时间"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [total.value > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        background: "",
        layout: "total,prev, pager, next",
        "hide-on-single-page": true,
        "current-page": page.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => page.value = $event),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        onCurrentChange: _cache[2] || (_cache[2] = $event => fetchList(page.value, pageSize.value)),
        total: total.value
      }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])])), [[_directive_loading, loading.value]]);
    };
  }
};